<form [formGroup]="evaluationForm" (ngSubmit)="saveEvaluation(inProgress)">
    <div class=" modal-header">
        <h5 class="modal-title d-flex align-items-center">
            <i class="ri-list-check-3 me-1 font-20 text-primary"></i>{{evaluation?.id?'Update':'Add'}}
            Evaluation
        </h5>
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
            (click)="activeModal.close('Close')"></button>
    </div>
    <div class="modal-body">
        <div class="row g-3">
            <div class="col-md-3">
                <label for="type" class="form-label">Appraisal</label>
                <div class="input-group"> <span
                        class="input-group-text bg-transparent border-end-0"><i
                            class='bx bxs-user-badge'></i></span>
                    <input type="text" class="form-control ps-1" id="type" readonly [value]="appraisal?.label"
                       
                        placeholder="Label" />
                </div>
            </div>
            <div class="col-md-3">
                <label for="start" class="form-label">Employee Submission Day</label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bxs-calendar-event'></i></span>
                    <input type="text" class="form-control ps-1" id="start"  [value]="appraisal?.employeeSubDay" readonly 
                      
                        placeholder="Employee Submission Day" />
                </div>
            </div>
            <div class="col-md-3">
                <label for="start" class="form-label">L1 Submission Day</label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bxs-calendar-event'></i></span>
                    <input type="text" class="form-control ps-1" id="start"  [value]="appraisal?.loneSubDay" 
                   
                     readonly placeholder="L1 Submission Day" />
                </div>
            </div>
            <div class="col-md-3">
                <label for="self" class="form-label">E Rating</label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-star'></i></span>
                    <input type="text" class="form-control ps-1" id="self"  [value]="employeeAssesment?.selfRating"
                   
                    readonly placeholder="E Rating" />
                </div>
            </div>
            <div class="col-md-3">
                <label for="self" class="form-label">L Rating</label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-star'></i></span>
                    <input type="text" class="form-control ps-1" id="self"   [value]="employeeAssesment?.loneRating"
                 
                    readonly placeholder="L Rating" />
                </div>
            </div>
            <div class="col-md-3">
                <label for="Performance" class="form-label">Performance</label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bxs-bar-chart-alt-2'></i></span>
                    <input type="text" class="form-control ps-1" id="Performance" [value]="employeeAssesment?.performanceLabel" 
                   
                     readonly placeholder="Performance" />
                </div>
            </div>
            <div class="col-md-6">
                <label for="matrics" class="form-label">Metrics</label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bxs-bar-chart-alt-2'></i></span>
                    <input type="text" class="form-control ps-1" id="matrics" [value]="employeeAssesment?.metricName"
                  
                    readonly placeholder="Matrics" />
                </div>
            </div>
            <div class="col-md-3">
                <label for="hike" class="form-label">Hike</label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-bar-chart-alt'></i></span>
                    <input type="text" class="form-control ps-1" id="hike"  [value]="hikeValue || 'Nill'" 
                    
                     readonly placeholder="Hike" />
                </div>
            </div>
            <div class="col-md-3">
                <label for="promotable" class="form-label">Promoted Role</label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bxs-bar-chart-alt-2'></i></span>
                    <input type="text" class="form-control ps-1" id="promotable" [value]="employeeAssesment?.promotable ? 'Yes' : 'No'"
                   
                    readonly placeholder="Promoted ROle" />
                </div>
            </div>
        </div>
        <div class="row g-3 mt-2">
            <div class="col-md-3">
                <label class="form-label">Approve <b class="text-secondary">*</b></label>
                <div class="d-flex align-items-center">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" id="yesOption" name="status"
                               value="APPROVED" formControlName="status" [class.disabled]="evaluationStatus" />
                        <label class="form-check-label" for="yesOption" >Yes</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" id="noOption" name="status"
                               value="REJECTED" formControlName="status" [class.disabled]="evaluationStatus"/>
                        <label class="form-check-label" for="noOption">No</label>
                    </div>
                </div>
            </div>  
            <div class="col-md-9">
                <label for="comment" class="form-label">Comment <b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-comment'></i></span>
                    <input type="text" class="form-control ps-1" id="comment" [readonly]="evaluationStatus"
                     formControlName="comments" [value]="evaluation?.comments" placeholder="comments" />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="activeModal.close('Close')"><i
                class="bx bx-x"></i>Close</button>
        <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}"
        [disabled]="evaluationStatus">
            <ng-container *ngIf="inProgress?.value=='true'">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{evaluation?.id?'Updating...':'Saving...'}}
            </ng-container>
            <ng-container *ngIf="inProgress?.value!='true'">
                <i class="bx bx-save"></i>{{evaluation?.id?'Save Changes':'Save'}}
            </ng-container>
        </button>
    </div>
</form>